module.exports = __webpack_public_path__ + "static/media/120-3.1935fc8f.svg";